import useAuth from 'hooks/useAuth';
import React from 'react';
import AutoCreateFromScratch from './AutoCreateFromScratch';
import ManualCreateFromScratch from './ManualCreateFromScratch';

type AppProps = {
  goBack: () => void;
  closeModal?: () => void;
  redirectTo?: 'estimates' | 'estimate-detail';
};

const CreateFromScratch: React.FC<AppProps> = ({
  goBack,
  closeModal,
  redirectTo = 'estimate-detail',
}) => {
  const { userInfo } = useAuth();
  if (userInfo?.controls?.can_use_auto_create_estimate_options) {
    return (
      <AutoCreateFromScratch
        goBack={goBack}
        closeModal={closeModal}
        redirectTo={redirectTo}
      />
    );
  }

  return (
    <ManualCreateFromScratch
      goBack={goBack}
      closeModal={closeModal}
      redirectTo={redirectTo}
    />
  );
};

export default CreateFromScratch;
